import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {IrbEditorsService} from "@irb/irb-editors/irb-editors.service";
import {
  IrbAgGridExportService
} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";

@Component({
  selector: 'irb-security-history',
  standalone: false,
  templateUrl: './security-history.component.html',
  styleUrl: './security-history.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SecurityHistoryComponent implements OnInit {

  @Input() securityId: any;
  isUiTest = false;
  gridOptions: any;
  grid: any;

  constructor(private ies: IrbEditorsService, public ges: IrbAgGridExportService) {
  }

  ngOnInit() {
    const colDef: any = this.getSecColumnDefs();
    let rowIdIteration = -1;
    this.gridOptions = {
      sortModel: [
        {colId: 'createdDate', sort: 'desc'}
      ],
      columnDefs: colDef,
      rowModelType: 'serverSide',
      floatingFilter: false,
      overlayLoadingTemplate: "<div class='loading-spinner'></div>",
      overlayNoRowsTemplate: "No results found.",
      context: {componentParent: this},
      getRowId: (params: any) => {
        rowIdIteration++;
        const rowId = 'RowId' + rowIdIteration;
        return params.data.securityId + rowId;
      }
    };
  }

  private getSecColumnDefs() {
    return [
      {
        headerName: "Timestamp",
        field: "createdDate",
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
        minWidth: 150,
        flex:1,
        suppressMovable: true
      },
      {
        headerName: "User",
        field: "createdBy",
        minWidth: 70,
        flex:1,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true
      },
      {
        headerName: "Attribute",
        field: "attributeName",
        minWidth: 50,
        flex:1,
        cellRenderer: 'cellRendererFormatter',
        suppressMovable: true
      },
      {
        headerName: "Previous Value",
        field: "previousValue",
        minWidth: 70,
        flex:1,
        suppressMovable: true,
        cellRenderer: 'cellRendererFormatter',
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        }
      },
      {
        headerName: "Updated Value",
        field: "updatedValue",
        suppressMovable: true,
        minWidth: 70,
        flex:1,
        cellRenderer: 'cellRendererFormatter',
        valueFormatter: (params: any) => {
          return params.value ? params.value : '-';
        }
      }
    ];
  }

  onGridReady(params: any) {
    this.grid = params;
    this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
  }

  setDatasource() {
    return {
      getRows: (params: any) => {
        this.ies.getSecurityHistory(params, this.securityId).subscribe({
          next:(response: any) => {
            let gridData: any = Array.isArray(response) ? response : [];
            if (gridData.length === 0 && this.grid.api.getDisplayedRowCount() <= 1) {
              this.grid.api.showNoRowsOverlay();
            } else {
              this.grid.api.hideOverlay();
            }
            params.success({rowData: gridData});
          },
          error: () => {
            params.success({rowData: []});
            this.grid.api.showNoRowsOverlay();
          }
        });
      }
    }
  }

  exportHistory() {
    this.ies.exportSecurityHistory(this.securityId).subscribe({
      next: (_res: any) => {
        this.ges.showSuccessMessage();
      }
    });
  }



}
